export const PAYMENT_METHOD = {
    FLEX_WALLET_DEDUCTION: 'flex_wallet_deduction',
    SALARY_DEDUCTION: 'salary_deduction',
};

export const normalizePaymentMethod = (method) => (
    method === PAYMENT_METHOD.SALARY_DEDUCTION
        ? PAYMENT_METHOD.SALARY_DEDUCTION
        : PAYMENT_METHOD.FLEX_WALLET_DEDUCTION
);

export const calculatePaymentBreakdown = (total, startingBalance, method) => {
    const amount = Number.isFinite(Number(total)) ? Number(total) : 0;
    const balance = Math.max(Number.isFinite(Number(startingBalance)) ? Number(startingBalance) : 0, 0);

    if (amount < 0) {
        return {walletDeduction: amount, salaryDeduction: 0, walletBalance: balance - amount};
    }
    if (normalizePaymentMethod(method) === PAYMENT_METHOD.SALARY_DEDUCTION) {
        return {walletDeduction: 0, salaryDeduction: amount, walletBalance: balance};
    }

    const walletDeduction = Math.min(amount, balance);
    return {
        walletDeduction,
        salaryDeduction: amount - walletDeduction,
        walletBalance: balance - walletDeduction,
    };
};
